import React, { FC } from 'react';
import cls from './ModalFooter.module.css';
import classNames from 'classnames';

export const ModalFooter = ({ children, classes }) => {
    return <div className={classNames(cls.customModalFooter, [classes])}>{children}</div>;
};
